const BlogListSkeleton = ({ count = 6 }) => (
  <div className="blog-card-grid blog-collection-grid" aria-hidden="true">
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="blog-card-grid-item blog-card-skeleton">
        <div className="blog-card-banner-wrap">
          <div className="blog-skeleton-banner" />
        </div>
        <div className="blog-card-body">
          <div className="blog-skeleton-icon" />
          <div className="blog-skeleton-line blog-skeleton-category" />
          <div className="blog-skeleton-line blog-skeleton-card-title" />
          <div className="blog-skeleton-line blog-skeleton-card-title-short" />
          <div className="blog-skeleton-line" />
          <div className="blog-skeleton-line blog-skeleton-line-short" />
          <div className="blog-skeleton-meta">
            <div className="blog-skeleton-pill" />
            <div className="blog-skeleton-pill blog-skeleton-pill-sm" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default BlogListSkeleton;
